import dynamic from 'next/dynamic';

import { SectionTitleProps } from '../../../components/blocks/SectionTitleBlock';
import { ContentBlockRenderer } from '../../../types/Block';
import { ContentstackSection } from '../../../types/Contentstack';
import { Transformer } from '../../../types/Transformer';

interface ContentstackSectionTitle extends ContentstackSection {
  title: string;
}

/* istanbul ignore next */
export const renderer: ContentBlockRenderer<SectionTitleProps> = {
  Component: dynamic<SectionTitleProps>(() =>
    import('src/components/blocks/SectionTitleBlock').then((mod) => mod.SectionTitleBlock),
  ),
};

export const transformer: Transformer<ContentstackSectionTitle, SectionTitleProps> = ({
  title,
  _metadata,
}) => ({
  uid: _metadata.uid,
  renderer,
  serializedData: {
    title,
  },
});
